import React from "react";
import QuoteDetailsInternal from "../../../components/QuoteDetailsInternal";

const QuoteDetails = () => {
  return (
    <div className="size-full p-6 xl:p-8 2xl:p-10">
      <QuoteDetailsInternal />
    </div>
  );
};

export default QuoteDetails;
